import services from '../services'

export default {
  async getUsers({ state, commit }, filter) {
    const { data } = await services.getUsers(filter)
    commit('SET_OBJECT', { name: 'users', data, state })
    return data
  },
  async editUser({ state, commit }, user) {
    const { data } = await services.editUser(user)
    return data
  },
  async getUserById({ state, commit }, id) {
    const data = await services.getUserById(id)
    return data
  },
}
